import React from 'react'


const OptionButton = (props) => {
  return (
    <button type={props.type} onClick={props.onClick} className={"p-2 flex justify-center items-center h-10 rounded-[20px] text-center border-[#FDE9D8] my-2 mr-2 text-sm  border-[1px] px-4 " + props.className}>{props.children}</button>
  )
}

export default OptionButton